import { createContext } from "react";

type PopupContextType = {
    canClose: boolean;
    closePopup: () => void;
    disableClose: () => void;
    enableClose: () => void;
    resetPopup: () => void;
    isOpen: boolean;
    openPopup: (content: React.ReactNode) => void;
};

export const PopupContext = createContext<PopupContextType | undefined>(undefined);
